/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { NOTIFICATIONS_SLICE_NAME } from '../../../app/constants';
import PageTitle from '../../../components/PageTitle';
import { t } from '../../../providers';
import { me as meSlice } from '../../AuthenticatedPage/authenticationSlice';
import {
    requestResult as resultSlice,
    loading as loadingSlice,
    error as errorSlice,
    selectedChildAccount as childAccountSlice,
} from '../accountSlice';
import ChildAccountCard from '../components/ChildAccountCard';
import { SLICE_NAME } from '../constants';

const useStyles = makeStyles(() => ({
    container: {
        height: '100%',
        padding: '4rem 4rem 0',
        maxWidth: '653px',
        '@media (max-width:600px)': {
            padding: '4rem 1rem 0',
        },
    },
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        marginBottom: '20px',
    },
    tabContainer: {
        width: '100%',
    },
    cardContainer: {
        '@media (min-width:1100px)': {
            width: '653px',
        },
    },
}));

const EditChildAccount = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const response = useSelector(resultSlice);
    const loading = useSelector(loadingSlice);
    const selectedChildAccount = useSelector(childAccountSlice);
    const error = useSelector(errorSlice);
    const me = useSelector(meSlice);
    const history = useHistory();

    useEffect(() => {
        if (!selectedChildAccount) history.push('/my-account/child-accounts');
        return () => dispatch({ type: `${SLICE_NAME}/selectedChildAccount`, payload: null });
    }, [selectedChildAccount, history, dispatch]);

    useEffect(() => {
        if (response && response.ok) {
            dispatch({ type: `${SLICE_NAME}/requestResult`, payload: null });
            if (response.fromAction === 'editChildAccount') {
                const payload = { message: t('information.successfully.modified') };
                dispatch({ type: `${NOTIFICATIONS_SLICE_NAME}/addNotification`, payload });

                const updatedChildUserName = response.userName;
                const { userName } = me;
                if (updatedChildUserName === userName) {
                    dispatch({ type: `${SLICE_NAME}/getAccountDetails`, payload: { fromAction: 'editChildAccount' } });
                }
            }
            history.push('/my-account/child-accounts');
        }
    }, [response, dispatch, history, me]);

    const saveAccount = (payload) => {
        dispatch({ type: `${SLICE_NAME}/editChildAccount`, payload });
    };
    const cancelAction = () => {
        history.push('/my-account/child-accounts');
    };

    return (
        <div>
            <PageTitle title={t('child.account.details')} details={t('add.new.child.account.description')} />
            <div className={classes.cardContainer}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <ChildAccountCard
                        saveAccount={saveAccount}
                        cancelAction={cancelAction}
                        error={error}
                        childAccount={selectedChildAccount || {}}
                        isEdit={true}
                    />
                )}
            </div>
        </div>
    );
};

export default EditChildAccount;
